import { createContext} from "react";

const PositionContext = createContext()

export default PositionContext